<template>
    <div>
        <CFTitle title="23. Activități previzionate"></CFTitle>
        <validation-observer #default="{ invalid }" ref="activitatiPrevizionate">
            <span class="display-none">{{ invalid }}</span>
            <M3Warn v-if="allActivities.length < 1" type="red-warn" text="Activitățile pot fi adăugate din pagina "><template v-slot:link><router-link to="/aplicatii/m3-sketch/activitati" style="margin-left: 5px; color: #ffffff; font-weight: 600">Activități</router-link></template></M3Warn>

            <div v-for="(activity, key) in allActivities" :key="key" class="activities-table">
                <table>
                    <thead>
                        <tr>
                            <th class="table-head blue-head" style="width: 24%"><p>Titlu activitate / subactivitate</p></th>
                            <th class="table-head blue-head" style="width: 24%"><p>Data start</p></th>
                            <th class="table-head blue-head" style="width: 24%"><p>Data încheiere</p></th>
                            <th class="table-head blue-head" style="width: 24%"><p>Parteneri implicați</p></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style="width: 24%">{{ activity.title }}</td>
                            <td style="width: 24%">LUNA {{ activity.date[0] }}</td>
                            <td style="width: 24%">LUNA {{ activity.date[1] - 1 }}</td>
                            <td style="width: 24%">{{ activity.partner }}</td>
                        </tr>
                    </tbody>
                </table>
                <validation-provider
                    #default="{ errors }"
                    rules="required"
                    class="mt-4"
                >
                    <b-form-group
                        label="Detaliere"
                        class="has-icon"
                    >
                        <b-form-textarea
                            v-model="activity.details"
                            :state="errors.length > 0 ? false : null"
                            rows="4"
                            :readonly="completed"
                        ></b-form-textarea>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                </validation-provider>
                <validation-provider
                    #default="{ errors }"
                    rules="required"
                    class="mt-3"
                >
                    <b-form-group
                        label="Rezultate previzionate"
                        class="has-icon"
                    >
                        <b-form-input
                            v-model="activity.results"
                            :state="errors.length > 0 ? false : null"
                            type="text"
                            :readonly="completed"
                        ></b-form-input>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                </validation-provider>
                <validation-provider
                    #default="{ errors }"
                    rules="required"
                    class="mt-3"
                >
                    <b-form-group
                        label="Amplasamente"
                        class="has-icon mt-3"
                    >
                        <v-select
                            v-model="activity.address"
                            dir="ltr"
                            :options="getAddresses"
                            label="title"
                            multiple
                            :reduce="(option) => option"
                            input-id="tags"
                            :state="errors.length > 0 ? false : null"
                            :closeOnSelect="false"
                            :class="completed ?'disabled-select':''"
                            class="selecteaza-companie"
                            :readonly="completed"
                        ></v-select>
                        <small class="text-danger">{{ errors[0] }}</small>
                        <small>Locațiile amplasamentelor sunt preluate din pagina <router-link to="/aplicatii/m3-sketch/proiectul-meu">Proiectul meu</router-link></small>
                    </b-form-group>
                </validation-provider>
                <table v-if="activity.address.length > 0">
                    <thead>
                        <tr>
                            <th class="table-head blue-head" style="width: 30%"><p>Denumire</p></th>
                            <th class="table-head blue-head" style="width: 70%"><p>Adresa</p></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(adresa, key2) in activity.address" :key="key2">
                            <td style="width: 30%">{{ adresa.number }}</td>
                            <td style="width: 70%">{{ adresa.address }}</td>
                        </tr>
                    </tbody>
                </table>
                <hr class="divider">
            </div>
            <b-form-checkbox
                v-model="completed"
                switch
                size="lg"
                class="switch-box"
                @change="sendForm()"
            >Informațiile sunt complete și corecte</b-form-checkbox>
        </validation-observer>
    </div>
</template>

<script>
    import CFTitle from "./CFTitle";
    import { BTable, BFormInput, BIconXCircleFill, BIconPlusCircleFill, BFormCheckbox, BFormGroup, BFormTextarea } from 'bootstrap-vue'
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    import _ from "lodash";
    import api from '@/helpers/api'
    import M3Warn from '@/pages/Aplicatii/M3/M3Sketch/components/M3Warn'
    import axios from '@/helpers/axios'
    import vSelect from 'vue-select'
    require('@/helpers/validations/validations')
    export default {
        components: {
            CFTitle,
            BTable, BFormInput, BIconXCircleFill, BIconPlusCircleFill, BFormCheckbox, BFormGroup, BFormTextarea,
            M3Warn,
            ValidationProvider, ValidationObserver,
            vSelect
        },
        props: {
            data: {
                type: Object,
                default: null
            },
            m3GrantApplication: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                completed: false,
                activities: [],
                subactivities: [],
                allActivities: [],
                showRedirectPopup: false,
            }
        },
        computed: {
            getAddresses() {
                let result = [];

                if(this.data && this.data.m3_project && this.data.m3_project.location_address && this.data.m3_project.location_address.length > 0){
                    this.data.m3_project.location_address.forEach((address, index) => {
                        let number = index+1
                        result.push({
                            address: address.address,
                            number: 'Locatia ' + number,
                            title: 'Locatia ' + number +  ' - ' + address.address
                        })
                    })
                }

                return result
            },
            finantareProgress() {
                return this.$store.getters['finantare/progress'];
            }
        },
        watch: {
            finantareProgress: {
                handler() {
                    if(this.finantareProgress.includes('Activitati previzionate'))
                        this.completed = true;
                },
                deep: true
            },
            data: {
                handler: function () {
                    if(this.m3GrantApplication && this.m3GrantApplication.activitati_previzionate){
                        this.allActivities = this.m3GrantApplication.activitati_previzionate
                    } else {
                        this.getActivitiesData()
                    }
                },
                deep: true
            },
        },
        mounted() {
            if(this.finantareProgress.includes('Activitati previzionate'))
                this.completed = true;
            if(this.m3GrantApplication && this.m3GrantApplication.activitati_previzionate && this.m3GrantApplication.activitati_previzionate.length){
                this.allActivities = this.m3GrantApplication.activitati_previzionate
                this.checkIds();
            } else {
                this.getActivitiesData()
                if(this.showRedirectPopup){
                    this.$swal({
                        heightAuto: false,
                        title: 'Activitățile nu au fost salvate corect.<br>' +
                            '<p style="font-size: 14px; text-align: center; margin-top: 15px;">Te rugăm să le salvezi din nou.</p>',
                        icon: 'info',
                        type: 'success',
                        confirmButtonText: 'Mergi la Activități'
                    }).then(() => {
                        this.$router.push('/aplicatii/m3-sketch/activitati?reset=true')
                    })
                }
            }
        },
        methods: {
            checkIds() {
                if(this.allActivities && this.allActivities.length && this.data && this.data.m3_project && this.data.m3_project.activities && this.data.m3_project.activities.activities){
                    let changesMade = false;
                    this.allActivities.forEach((activity, index) => {
                        if(!activity.results || activity.address.length === 0 || !activity.details)
                            this.completed = false;

                        if(!activity.id){
                            changesMade = true
                            this.data.m3_project.activities.activities.forEach(mainActivity => {
                                if(activity.title === ('A' + mainActivity.number + ' ' + mainActivity.title)){
                                    activity.id = mainActivity.id;
                                }

                                if(!activity.id){
                                    mainActivity.childrens.forEach(child => {
                                        if(activity.title === (mainActivity.number + '.' + child.number + ' ' + child.title)){
                                            activity.id = child.id;
                                        }
                                    })
                                }
                            })

                            if(!activity.id){
                                this.allActivities.splice(index, 1);
                            }
                        }
                    })

                    if(changesMade){
                        axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/grant-application',  {activitati_previzionate: this.allActivities})
                            .then( () => {
                                this.$emit('savedData')
                                this.completed = false;
                                this.$store.dispatch('finantare/removeFromProgress', 'Activitati previzionate')
                            })
                    }

                }
            },
            getActivitiesData() {
                if(this.data && this.data.m3_project && this.data.m3_project.activities && this.data.m3_project.activities.activities && this.data.m3_project.activities.activities.length > 0) {
                    let BreakException = {};
                    try {
                        this.data.m3_project.activities.activities.forEach(activity => {
                            let min = 25;
                            let max = 0;
                            this.subactivities = [];

                            if(this.checkActivity(activity))
                                throw BreakException;

                            activity.childrens.forEach(child => {
                                this.subactivities.push({
                                    id: child.id,
                                    title: activity.number + '.' + child.number + ' ' + child.title,
                                    date: child.date,
                                    partner: JSON.parse(localStorage.getItem('currentM3Company')).name,
                                    details: '',
                                    results: '',
                                    address: this.getAddresses && this.getAddresses.length === 1 ? [this.getAddresses[0]] : []
                                })
                                if(min > child.date[0])
                                    min = child.date[0]

                                if(max < child.date[1])
                                    max = child.date[1]
                            })

                            this.allActivities.push({
                                id: activity.id,
                                title: 'A' + activity.number + ' ' + activity.title,
                                date: [ min, max ],
                                partner: JSON.parse(localStorage.getItem('currentM3Company')).name,
                                details: '',
                                results: '',
                                address: this.getAddresses && this.getAddresses.length === 1 ? [this.getAddresses[0]] : []
                            })

                            this.allActivities = _.union(this.allActivities, this.subactivities)
                        })
                    } catch (e) {
                        if (e !== BreakException) throw e;
                    }
                }
            },
            checkActivity(activity) {
                activity.childrens.forEach(child => {
                    if(!(child.date && child.date.length > 1)){
                        this.showRedirectPopup = true;
                    }
                })
                return this.showRedirectPopup;
            },
            sendForm() {
                if(this.completed){
                    this.$refs.activitatiPrevizionate.validate().then((e) => {
                        if (!e) {
                            this.completed = false
                            this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                        } else {
                            axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/grant-application',  {activitati_previzionate: this.allActivities})
                                .then( () => {
                                    this.$toast.success('Informațiile au fost salvate!')
                                    this.$emit('savedData')
                                    this.$store.dispatch('finantare/addToProgress', 'Activitati previzionate')
                                })
                        }
                    })
                }
                else{
                    this.$store.dispatch('finantare/removeFromProgress', 'Activitati previzionate')
                }
            }
        }
    }
</script>

<style scoped>
.text-info{

}
.activities-table{
    margin-top: 40px;
}
.activities-table table{
    margin-bottom: 15px;
}
table, th, td {
    border: 1px solid #979696;
    width: 100%;
    height: 100%;
    text-align: center;
}
td{
    font-size: 14px;
    padding: 5px;
}
.padding-td tr td:first-child{
    padding: 10px;
}
.table-head p{
    font-size: 14px;
    text-align: center;
    font-weight: 700;
    text-transform: uppercase;
}
.table-head{
    padding: 10px;
    border: 1px solid #979696;
    border-bottom: 0;
    position: relative;
}
.blue-head{
    background: #bdd6ee;
}
.form-group >>> legend{
    text-align: left;
}
.divider{
    margin: 50px 0;
}
.v-select >>> .vs__dropdown-menu {
    background: #e9ecef;
    max-height: 200px;
    overflow-y: hidden;
}
.v-select >>> .vs__dropdown-toggle{
    background: #e9ecef;
    margin: 0;
    border-radius: 2px;
    justify-content: space-between;
    align-items: center;
    max-height: 33px;
}
.v-select >>> .vs__actions{
    padding: 0;
}
.v-select >>> .vs__dropdown-option {
    color: #767a95;
    font-size: 13px;
    padding-left: 5px;
    font-weight: 600;
}
.v-select >>> .vs__search{
    margin: 0;
    padding: 0;
}
.v-select >>> .vs__selected{
    color: #767a95;
    font-size: 14px;
    font-weight: 600;
    margin: 0;
}
.disabled-select{
    pointer-events: none;
}
.disabled-select >>> .vs__dropdown-toggle, .disabled-select >>> .vs__selected-options, .disabled-select >>> input{
    background: #d1f5ea!important;
    color:#b2b6be!important;
}
textarea {
    border-radius: 2px;
    padding: 5px 10px;
    height: inherit;
    font-size: 14px;
    font-weight: 700;
    color: #767a95;
    background: #e9ecef;
}
</style>
